export enum OwnershipTransferTabOption {
    RECEIVED = 'received',
    SENT = 'sent',
    ORG_VIEWS = 'orgViews',
}
